export enum UserPreferredShortDateFormat {
  DefaultFormat = 'dd/mm/yyyy',
  DotFormat = 'dd.mm.yyyy',
  HyphenFormat = 'dd-mm-yyyy',
  MonthFirstFormat = 'mm/dd/yyyy',
}
